module.exports = __webpack_public_path__ + "img/purple.9d41a31f.svg";